import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { Card, CardBody, Container } from 'reactstrap'
import General from '../GeneralTab'
import Location from '../Location'

const Coveredentitytable = (props) => {
    const {
        Cedata,setCEflag,orgId,rowData,setConfigFlag,
        configflag,setLoading,
        loading} = props;
                  const [key, setkey] = useState("general");
                    const [reset, setReset] = useState(false);
                  
                  const onKeyChange = (k) => {
                    setkey(k);
                 setReset(!reset);
                  };
        
  return (
    <div>
        <Container fluid className="my-3 bin_info p-0">
        <Card className='border-0 shadow-top mt-3'>
          <CardBody>
          <Tabs
          id="controlled-tab-example"
          activeKey={key}
          // onSelect={(k) => setkey(k)}
          onSelect={(k) => onKeyChange(k)}
          className="mb-3"
        >
          {/* <Tab eventKey="accumulatorTab" title="Accumulator">
            {loading && <Loader opacity={0.02} color="black" />}
            <AccumulatorTab
              AccumulatorTable={AccumulatorTable}
              rowData={rowData}
              accmulatorRecords={accmulatorRecords}
              handelAccumulator={handelAccumulator}
              handelSort={handlePageChange}
              filter={search}
              onSearchColumnFilter={handleSearchColumnFilters}
            />
          </Tab> */}
          <Tab eventKey="general" title="General">
            {/* {loading && <Loader opacity={0.02} color="black" />} */}
            <General
            //   rowData={rowData}
            //   SelectedAccumulatorOrder={rowData.accumulatorID}
            />
          </Tab>
          {/* {loading && <Loader opacity={0.02} color="black" />} */}
{/* 
          <Tab eventKey="locationTab" title="Location">
            <Location
              orgId={orgId}
              key={key}
              rowData={rowData}
              SelectedAccumulator={rowData?.accumulatorID}
            />
          </Tab> */}
         
        </Tabs>
          </CardBody>
        </Card>
        </Container>
    </div>
  )
}

export default Coveredentitytable